module.exports = __webpack_public_path__ + "img/D201706_6.c74cf777.jpg";